import { StyleSheet } from 'aphrodite'

import gamebox from './gamebox'
import main from './main'
import sidebar from './sidebar'

export default {
  main: StyleSheet.create(main),
  gamebox: StyleSheet.create(gamebox),
  sidebar: StyleSheet.create(sidebar)
}



// WEBPACK FOOTER //
// ./src/components/Games/style/index.js